import { render, staticRenderFns } from "./simulation.html?vue&type=template&id=803e1cc2&scoped=true&"
import script from "./simulation.js?vue&type=script&lang=js&"
export * from "./simulation.js?vue&type=script&lang=js&"
import style0 from "./simulation.scss?vue&type=style&index=0&id=803e1cc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803e1cc2",
  null
  
)

export default component.exports